import React from "react";
import { NavLink, useLocation, useSearchParams } from "react-router";

import { cn } from "~/lib/utils";

type AppLinkProps = {
  to: string;
  className?: string;
  activeClassName?: string;
  matchHash?: boolean;
  matchSearchParams?: string[];
  children: React.ReactNode;
};

// Wrapper around NavLink that supports placing it in components that
// expect className to be a string
const AppLink = React.forwardRef<any, AppLinkProps>((props, ref) => {
  const location = useLocation();
  const locationHash = location.hash.slice(1);
  const linkHash = props.to.split("#")[1] || "";
  const [searchParams] = useSearchParams();

  const toSearchParams = new URLSearchParams(props.to.split("?")[1]);
  const searchParamsMatch =
    !props.matchSearchParams ||
    props.matchSearchParams.every(
      (param) => searchParams.get(param) === toSearchParams.get(param),
    );

  const hashesMatch = !props.matchHash || linkHash == locationHash;

  return (
    <NavLink
      end
      ref={ref}
      to={props.to}
      className={({ isActive }) => {
        return cn("text-gray-700", props.className, {
          [props.activeClassName || ""]: isActive && searchParamsMatch && hashesMatch,
        });
      }}
    >
      {props.children}
    </NavLink>
  );
});

AppLink.displayName = "AppLink";

export default AppLink;
